import React from 'react';
import { useSelector } from 'react-redux';
import * as S from './SeoInterLinking.styles';
import { interlinkingSelector } from '../../redux/selector';

export default function () {
   const interlinking = useSelector(interlinkingSelector);
   if (interlinking?.length === 0) {
       return null;
   }
   return (
       <S.InterlinkingContainer>
           {interlinking?.map(({ title = '', links = [] }) => (
               <S.InterlinkingItemContainer key={title}>
                   <S.InterlinkingItemTitle>{title}</S.InterlinkingItemTitle>
                    {links?.map((item, index) => {
                        const last = !!(index === links?.length - 1);
                        return (
                            <S.InterlinkingItem key={item.text} href={item?.url}>{last ? item.text : `${item.text} | `}</S.InterlinkingItem>
                        )
                    })}
               </S.InterlinkingItemContainer>
           ))}
        </S.InterlinkingContainer>
   )
}